/* unplugin-vue-components disabled */import script from "./SubMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./SubMenu.vue?vue&type=script&setup=true&lang=ts"

import "./SubMenu.vue?vue&type=style&index=0&id=5c4ccb1a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c4ccb1a"]])

export default __exports__